/* eslint-disable no-throw-literal */
import store from '../store';
import space_permission from './space_pemission';

export function topic_permission(action, topic = null) {
    /* Check the access to topic by action. eg: SPACE_UPDATE */
    const { space_permissions } = store.state.configurations;
    const roles = space_permissions[action];
    return topic === null || !topic.is_private || roles.includes(topic.role);
}

export function space_topic_permission(action, topic, space = null) {
    const current_space = space || store.state.spaces.detail.data;

    if (current_space && current_space.roles.includes('admin')) {
        return true;
    }

    if (topic && topic.is_private) {
        return topic_permission(action, topic);
    }
    return space_permission(action, space);
}
